import {useTitle} from 'hooks';
import {NavbarCommon} from 'components';
import Impersonate from './components/Impersonate';

interface IPageImpersonateProps {}

const PageImpersonate = ({}: IPageImpersonateProps) => {
  useTitle('Impersonate');
  return (
    <div className="min-h-screen flex flex-col">
      <NavbarCommon />
      <Impersonate />
    </div>
  );
};

export default PageImpersonate;
